const es = {
    'orgChart.alert.collapse_success': 'Todos los nodos se han juntado correctamente',
    'orgChart.alert.error': 'Error',
    'orgChart.alert.expand_success': 'Todos los nodos se han desplegado correctamente',
    'orgChart.alert.missing_data': 'Por favor, rellena todos los campos',
    'orgChart.alert.node_added': 'Nodo añadido correctamente',
    'orgChart.alert.node_deleted': 'Nodo eliminado correctamente',
    'orgChart.alert.node_has_children': 'No se puede eliminar porque tiene hijos',
    'orgChart.alert.node_updated': 'Nodo modificado correctamente',
    'orgChart.alert.success': 'Confirmado',
    'orgChart.button.add_node': 'Añadir nodo',
    'orgChart.button.cancel': 'Cancelar',
    'orgChart.button.collapse_all': 'Juntar todo',
    'orgChart.button.delete': 'Eliminar',
    'orgChart.button.expand_all': 'Desplegar todo',
    'orgChart.button.hide_form': 'Ocultar formulario',
    'orgChart.button.modify_node': 'Modificar nodo',
    'orgChart.button.show_form': 'Mostrar formulario',
    'orgChart.confirm.delete_node_title': 'Eliminar Nodo',
    'orgChart.confirm.delete_node': '¿Desea eliminar este nodo?',
    'orgChart.error.add_failed': 'Ha ocurrido un error al añadir',
    'orgChart.error.delete_failed': 'Error al eliminar el nodo',
    'orgChart.error.load_failed': 'Error al cargar los datos del organigrama:',
    'orgChart.error.modify_failed': 'Ha ocurrido un error al modificar el nodo',
    'orgChart.form.add_node': 'Formulario añadir nodo',
    'orgChart.form.modify_node': 'Formulario modificar nodo',
    'orgChart.form.position_id': 'Posición',
    'orgChart.form.required_fields': 'Todos los campos son obligatorios',
    'orgChart.form.select_user': 'Usuario',
    'orgChart.form.title': 'Título',
    'orgChart.tab.extras': 'Extras',
    'orgChart.tab.functional': 'Funcional',
    'orgChart.tab.salaries': 'Salarios',
    'orgChart.title.orgChart': 'Organigrama',
    'orgChart.title.publicOrgChart': 'Organigrama de la Empresa',
    'ui.menus.user.organigrama': 'Organigrama',
    'ui.menus.user.vacaciones': 'Vacaciones',
    'ui.menus.user.extras': 'Extras',
    'ui.menus.user.empresa': 'Empresa'
};

export default es;